import { useState, useEffect } from "react";
import "../styles/piranigal.css";
import Loader from "./Loader.jsx";

const Piranigal = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [sliderImages, setsliderImages] = useState("tab1");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/home.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.sliderImages) {
          setsliderImages(data.sliderImages);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let interval;
    if (isAutoPlaying && !isFullscreen) {
      interval = setInterval(() => {
        setCurrentSlide((prev) =>
          prev === sliderImages.length - 1 ? 0 : prev + 1
        );
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [sliderImages.length, isAutoPlaying, isFullscreen]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToNext = () => {
    setCurrentSlide((prev) =>
      prev === sliderImages.length - 1 ? 0 : prev + 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1
    );
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
    setIsAutoPlaying(false);
  };

  const handleKeyDown = (e) => {
    if (isFullscreen) {
      if (e.key === "Escape") {
        toggleFullscreen();
      } else if (e.key === "ArrowRight") {
        goToNext();
      } else if (e.key === "ArrowLeft") {
        goToPrev();
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isFullscreen, currentSlide]);

  if (loading) return <Loader />;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="sirappu-page3">
      <h2 className="heading">பங்கேற்கும் பிற நிகழ்ச்சிகள்</h2>
      <div className="slider-container3">
        {sliderImages.map((image, index) => (
          <div
            key={index}
            className={`slide3 ${index === currentSlide ? "active" : ""}`}
            style={{ backgroundImage: `url(${image})` }}
            onMouseEnter={() => goToSlide(index)}
            onClick={toggleFullscreen}
          />
        ))}

        <button className="slider-btn3 prev-btn" onClick={goToPrev}>
          &lt;
        </button>
        <button className="slider-btn3 next-btn" onClick={goToNext}>
          &gt;
        </button>

        <div className="slider-dots">
          {sliderImages.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>

      {isFullscreen && (
        <div className="fullscreen-overlay" onClick={toggleFullscreen}>
          <div
            className="fullscreen-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-fullscreen" onClick={toggleFullscreen}>
              &times;
            </button>
            <img
              src={sliderImages[currentSlide]}
              alt={`Slide ${currentSlide + 1}`}
              className="fullscreen-image"
            />
            <button className="fullscreen-button prev" onClick={goToPrev}>
              &lt;
            </button>
            <button className="fullscreen-button next" onClick={goToNext}>
              &gt;
            </button>
            <div className="fullscreen-dots">
              {sliderImages.map((_, index) => (
                <span
                  key={index}
                  className={`fullscreen-dot ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="content-container">
        <h1 className="title">
          மக்கள் சிந்தனைப் பேரவையின் சார்பில் ஓவிய ஆசிரியர்களுக்கான ஒரு நாள்
          பயிலரங்கம்
        </h1>
        <div className="divider"></div>
        <p className="description">
          மக்கள் சிந்தனைப் பேரவையின் சார்பில் ஈரோடு வருவாய் மாவட்டத்திற்குட்பட்ட
          ஈரோடு, கோபி கல்வி மாவட்டங்களிலுள்ள அரசு மற்றும் தனியார் பள்ளிகளில்
        </p>
      </div>
    </div>
  );
};

export default Piranigal;
